import MDBox from "components/MDBox";
import UiButton from "components/base/UiButton";
import UiSideModal from "components/base/UiSideModal";
import { CustomGetProposalQueryData } from "hooks/proposals/useCustomGetProposal";
import useModalState from "hooks/useModalState";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import LabeledValue from "./LabeledValue";

type MarginsDrawerProps = {
  proposal: NonNullable<CustomGetProposalQueryData>;
};

export default function MarginsDrawer({ proposal }: MarginsDrawerProps) {
  const { open, onOpen, onClose } = useModalState();

  return (
    <>
      <UiButton
        uiVariant="outlined"
        onClick={onOpen}
        sx={{ boxShadow: "none !important", flexShrink: 0, alignSelf: "flex-start" }}
      >
        Margins
      </UiButton>

      <UiSideModal open={open} onClose={onClose} title="Margins" width="420px">
        <MDBox display="flex" flexDirection="column" gap="16px" p="24px">
          <LabeledValue
            label="Gross Margin"
            value={formatCentsToUSD(proposal.grossMargin ?? 0)}
            boldValue
          />
          <LabeledValue label="Gross Margin %" value={`${proposal.grossMarginPercentage ?? 0}%`} />
          <LabeledValue
            label="Operating Margin"
            value={formatCentsToUSD(proposal.operatingMargin ?? 0)}
            boldValue
          />
          <LabeledValue
            label="Operating Margin %"
            value={`${proposal.operatingMarginPercentage ?? 0}%`}
          />
          <LabeledValue
            label="Profit Margin"
            value={formatCentsToUSD(proposal.netMargin ?? 0)}
            boldValue
          />
          <LabeledValue label="Profit Margin %" value={`${proposal.netMarginPercentage ?? 0}%`} />
        </MDBox>
      </UiSideModal>
    </>
  );
}
